// ComboQuantityControl.jsx
import PropTypes from "prop-types";
import { Box, IconButton, Typography } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

export default function ComboQuantityControl({ cantidad, onChange }) {
  const handleDecrement = () => {
    if (cantidad > 1) {
      onChange(cantidad - 1);
    }
  };

  const handleIncrement = () => {
    onChange(cantidad + 1);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      mt={1}
      width={"100%"}
      sx={{ justifyContent: "space-between" }}
    >
      <IconButton
        size="small"
        onClick={handleDecrement}
        disabled={cantidad <= 1}
        color="white"
        sx={{
          border: "1px solid",
          borderRadius: 1,
          bgcolor: "transparent",
          color: "white",
          p: 0,
          "&:disabled": {
            color: "gray",
          },
        }}
      >
        <RemoveIcon sx={{ fontSize: "20px" }} />
      </IconButton>
      <Typography
        variant="body1"
        fontWeight="bold"
        minWidth={20}
        textAlign="center"
      >
        {cantidad}
      </Typography>
      <IconButton
        size="small"
        onClick={handleIncrement}
        color="white"
        sx={{
          border: "1px solid",
          borderRadius: 1,
          bgcolor: "transparent",
          color: "white",
          p: 0,
        }}
      >
        <AddIcon sx={{ fontSize: "20px" }} />
      </IconButton>
    </Box>
  );
}

ComboQuantityControl.propTypes = {
  cantidad: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};
